import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import SimulationSetup from '../components/SimulationSetup';
import SimulationsList from '../components/SimulationsList';

const SimulationPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [selectedPortfolio, setSelectedPortfolio] = useState(null);
  const [portfolios, setPortfolios] = useState([]);
  const [activeTab, setActiveTab] = useState('list'); // 'setup' or 'list' - по умолчанию показываем список
  const [refreshSimulations, setRefreshSimulations] = useState(0);

  const portfolioId = searchParams.get('portfolioId');

  useEffect(() => {
    fetchPortfolios();
  }, []);

  useEffect(() => {
    if (portfolioId && portfolios.length > 0) {
      const portfolio = portfolios.find(p => p.id === portfolioId);
      if (portfolio) {
        setSelectedPortfolio(portfolio);
      }
    }
  }, [portfolioId, portfolios]);

  const fetchPortfolios = async () => {
    try {
      const response = await fetch('/api/v1/portfolios');
      const data = await response.json();
      setPortfolios(data.portfolios || []);
    } catch (error) {
      console.error('Error fetching portfolios:', error);
    }
  };

  const handleSimulationCreated = () => {
    // Переключаемся на вкладку со списком симуляций
    setActiveTab('list');
    // Обновляем список симуляций
    setRefreshSimulations(prev => prev + 1);
  };



  return (
    <div className="create-portfolio">
      {/* Header */}
      <div className="header">
        <button
          className="back-button"
          onClick={() => navigate('/')}
        >
          ← Back to Dashboard
        </button>
        <h1>Portfolio Simulation</h1>
      </div>

      {selectedPortfolio ? (
        <div>
          {/* Portfolio Info */}
          <div className="portfolio-form" style={{ marginBottom: '2rem' }}>
            <div className="form-section">
              <h2>{selectedPortfolio.name}</h2>
              <p style={{ fontSize: '1.2rem', color: '#28a745', fontWeight: 'bold', margin: '0.5rem 0' }}>
                Portfolio Value: ${selectedPortfolio.total_value?.toLocaleString() || 'N/A'}
              </p>

              <div style={{ marginTop: '1rem' }}>
                <h3>Asset Allocation:</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '1rem', marginTop: '0.5rem' }}>
                  {selectedPortfolio.assets?.map((asset, index) => (
                    <div key={index} style={{
                      background: '#f8f9fa',
                      border: '1px solid #dee2e6',
                      borderRadius: '4px',
                      padding: '0.75rem',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontWeight: 'bold', color: '#495057' }}>{asset.symbol}</div>
                      <div style={{ color: '#007bff', fontWeight: '600' }}>{asset.percentage}%</div>
                      <div style={{ fontSize: '0.875rem', color: '#6c757d' }}>
                        ${asset.amount?.toLocaleString()}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="portfolio-form">
            {activeTab === 'list' ? (
              <div>
                {/* Header with Create Button */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
                  <div>
                    <h2 style={{ margin: '0 0 0.5rem 0' }}>Portfolio Simulations</h2>
                    <p style={{ margin: 0, color: '#6c757d' }}>
                      Manage and track simulations for {selectedPortfolio.name}
                    </p>
                  </div>
                  <button
                    onClick={() => setActiveTab('setup')}
                    style={{
                      background: '#007bff',
                      color: 'white',
                      border: 'none',
                      padding: '0.75rem 1.5rem',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontWeight: '500'
                    }}
                  >
                    + Create New Simulation
                  </button>
                </div>

                {/* Simulations List */}
                <SimulationsList
                  portfolio={selectedPortfolio}
                  refreshTrigger={refreshSimulations}
                  onCreateNew={() => setActiveTab('setup')}
                  onViewResults={(simulation) => {
                    console.log('Переход на страницу результатов для симуляции:', simulation.id);
                    navigate(`/simulation-results?id=${simulation.id}`);
                  }}
                />
              </div>
            ) : (
              <div>
                {/* Setup Header */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
                  <div>
                    <h2 style={{ margin: '0 0 0.5rem 0' }}>Create New Simulation</h2>
                    <p style={{ margin: 0, color: '#6c757d' }}>
                      Configure parameters for {selectedPortfolio.name} simulation
                    </p>
                  </div>
                  <button
                    onClick={() => setActiveTab('list')}
                    className="back-button"
                  >
                    ← Back to List
                  </button>
                </div>

                {/* Simulation Setup */}
                <SimulationSetup
                  selectedPortfolio={selectedPortfolio}
                  onSimulationCreated={handleSimulationCreated}
                />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="portfolio-form" style={{ textAlign: 'center', padding: '4rem 2rem' }}>
          <h2>No Portfolio Selected</h2>
          <p style={{ color: '#6c757d', margin: '1rem 0 2rem' }}>
            Please select a portfolio from the Dashboard to create and manage simulations.
          </p>
          <button
            onClick={() => navigate('/')}
            style={{
              background: '#007bff',
              color: 'white',
              border: 'none',
              padding: '1rem 2rem',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: '500'
            }}
          >
            Go to Dashboard
          </button>
        </div>
      )}
    </div>
  );
};

export default SimulationPage;
